import { type WithTranslation, withTranslation } from 'react-i18next';
import Avatar from '@/components/Avatar';
import { type AvatarInfo } from '@/types';

type Props = {
  user?: AvatarInfo;
} & WithTranslation;

const ProfileAvatar = ({ user }: Props) => <Avatar user={user} />;

export default withTranslation()(ProfileAvatar);
